
if (typeof Object.assign != 'function') {
  Object.assign = function(target) {
    'use strict';
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    target = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index];
      if (source != null) {
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}

var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

var isEdge = false;
if (document.documentMode || /Edge/.test(navigator.userAgent) || /Edg/.test(navigator.userAgent)) {
  isEdge = true;
}

var Promise = require('es6-promise').Promise;
require('isomorphic-fetch');
require('es6-shim');
// require('es6-promise/auto');
import "@babel/polyfill";
import Vue from 'vue';
import Components from "./components";
import EventBus from './utils/event-bus';
import Vuelidate from 'vuelidate';
import VueAnalytics from 'vue-analytics';
import * as scrll from './funcs.js';
import Cookies from 'js-cookie';
import axios from 'axios';
import getDistance from 'geolib/es/getDistance';
import * as openHours from './utils/open-hours';
import objectFitImages from 'object-fit-images';
import 'picturefill';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';

import './notices';
import './dialog';
import './site-by-brighter';

Vue.use(Vuelidate);

Vue.use(VueAnalytics, {
  id: ['UA-25138126-12', 'G-DJS1RR5XVE'],
  autoTracking: {
    page: false
  }
});

new Vue({
  el: "#app",
  delimiters: ["${", "}"],
  data: {
    showStoreSwitch: false,
    showStoreMode: 'find',
    showNav: false,
    localStore: false,
    // geo: Cookies.get('crowiesGeo'),
    geo: null,
    showCallBackForm: false,
    allStores: {},
    showStoresList: false
  },
  computed: {

    openNow() {
      return openHours.display(this.localStore);
    },

    openNowSimple() {
      return openHours.displaySimple(this.localStore);
    },

    localStoreTel() {
      return 'tel:' + this.localStore.phone;
    }

  },
  methods: {

    saveGeo(json) {
      // console.log(json);
      this.geo = {
        'lat': json.latitude,
        'lng': json.longitude,
        'city': json.city,
        'state': json.state_prov,
        'postcode': json.zipcode
      };
      // console.log(JSON.stringify(this.geo));
      Cookies.set('crowiesGeo', JSON.stringify(this.geo), { expires: 7 });
      this.saveLocalFromGeo();
    },

    displayHours(slot) {
      var timeString = slot.day + ' ';
      if (!slot.closed) {
        var dayjs = require('dayjs');
        var customParseFormat = require('dayjs/plugin/customParseFormat');
        dayjs.extend(customParseFormat);
        var ot = dayjs(slot.openTime.date.replace(/-/g,'/').replace('.000000',''));
        var ct = dayjs(slot.closeTime.date.replace(/-/g,'/').replace('.000000',''));
        timeString += ot.format('h:mma') + ' - ' + ct.format('h:mma');
      } else {
        timeString += '- Closed';
      }
      return timeString;
    },

    displayDate(theDate) {
      // return 'te';
      var dayjs = require('dayjs');
      var day = dayjs(theDate.date.replace(/-/g,'/').replace('.000000',''));
      var dateString = day.format('Do MMM');
      return dateString;
    },

    async getCities() {
      try {
        const res = await axios.get('/js/cities.au.min.json');
        const cities = res.data;
        EventBus.$emit('LOAD_CITIES', cities);
      } catch (e) {
        console.error(e);
      }
    },

    saveLocal(storeId) {
      window.stores.filter(store => {
        if (store.id == storeId) {
          EventBus.$emit('LOCALSTORE_SET', store);
          EventBus.$emit('LOCALSTORE_EMIT', store);
        }
      });
      return false;
    },

    localStoreSet(localStore) {
      // console.log(localStore);
      this.localStore = localStore;
      Cookies.set('crowiesStore', localStore.slug, { expires: 7 });
      EventBus.$emit('LOCALSTORE_EMIT', this.localStore);
      this.showStoreSwitch = false;
    },

    showStoreDetails(e) {
      this.showStoreSwitch = !this.showStoreSwitch;
      if (this.localStore) {
        this.showStoreMode = 'local';
      } else {
        this.showStoreMode = 'find';
      }
      e.preventDefault();
      return false;
    },

    showStoreFind(e) {
      this.showStoreSwitch = !this.showStoreSwitch;
      this.showStoreMode = 'find';
      $('.storeswitch-input').focus();
      e.preventDefault();
      return false;
    },

    showStoreClose(e) {
      this.showStoreSwitch = !this.showStoreSwitch
      $('.localbarlink').focus();
    },

    saveLocalFromGeo() {

      var localStores = [];

      stores.forEach(store => {
        var dist = getDistance(
            { latitude: this.geo.lat, longitude: this.geo.lng },
            { latitude: store.lat, longitude: store.lng }
        );
        dist = dist / 1000; // convert to kms
        // if (dist < 10) {
        store.distance = dist.toFixed(2);
        // }
        localStores.push(store);
      });

      localStores.sort(function(a, b) {
          return a.distance - b.distance;
      });

      if (localStores[0].distance < 10) {
        this.localStoreSet(localStores[0]);
        EventBus.$emit('LOCALSTORE_SET', localStores[0]);
      }

    },

    showCallBackFormModal(e) {
      this.showCallBackForm = !this.showCallBackForm;
    }



  },
  mounted() {

    var crowiesStore = Cookies.get('crowiesStore');

    // if we've got local store cookie saved, use it
    if (typeof crowiesStore !== 'undefined') {

      var matchStore = stores.filter((store) => {

        if (store.slug == crowiesStore) {
          return true;
        }

        return false;

      });
      if (matchStore.length) {
        this.localStore = matchStore[0];
      }

    // if we've got geo cookie saved, use it
    } else if (typeof this.geo !== 'undefined' && this.geo !== null) {

      var isJson = true;
      try {
        this.geo = JSON.parse(this.geo);
      } catch (e) {
        isJson = false;
        this.geo = {};
      }


    // if all else fails, do a geolocation check
    } else {
      if (!isIE11) {
        if (isEdge) {
          var IPGeolocationAPI = require('./ip-geolocation-api-javascript-sdk-edge');
        } else {
          var IPGeolocationAPI = require('ip-geolocation-api-javascript-sdk');
        }
        var ipgeolocationApi = new IPGeolocationAPI('489c10faf7f94f2abc84cfc9a658330f', true);
        ipgeolocationApi.getGeolocation(this.saveGeo);
      }
      // console.log(ipgeolocationApi);
    }


    // if localStore already saved
    if (this.localStore) {
      EventBus.$emit('LOCALSTORE_EMIT', this.localStore);

    // if not, find it
    } else if (this.geo) {
      this.saveLocalFromGeo();

    }

    EventBus.$on('LOCALSTORE_SET', (localStore) => {
      this.localStoreSet(localStore);
    });

    this.getCities();

    if (typeof window.stores !== 'undefined') {
      this.allStores = window.stores;
    }

  }
});


//* is touch device =================================================== */

var isTouch = false;
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
  isTouch = true;
}


//* breakpoints =================================================== */

function breakpointWidth(bp) {
  var bpWidth = 768;
  if (bp == 'baby') {
    bpWidth = 479;
  }
  if (bp == 'teen') {
    bpWidth = 600;
  }
  if (bp == 'mama') {
    bpWidth = 768;
  }
  if (bp == 'mega') {
    bpWidth = 1279;
  }
  return bpWidth;
}

function breakpointMax(bp) {
  var bpWidth = breakpointWidth(bp);
  if ($(window).width() <= bpWidth) {
    return true;
  } else {
    return false;
  }
  return true;
}

function breakpointMin(bp) {
  var bpWidth = breakpointWidth(bp);
  if ($(window).width() > bpWidth) {
    return true;
  } else {
    return false;
  }
  return true;
}


//* objectfit polyfill =================================================== */
objectFitImages();


//* scroll to anchor =================================================== */

// all hashtags
$(document).on('click','a[href^="#"]',function(){
  var $this = $(this);
  var aId = $this.attr('href').replace('#','');;
  var $anchorElement = $('[id="' + aId + '"], [name="' + aId + '"], [data-id="' + aId + '"]');
  if ($anchorElement.length > 0) {
    scrll.scrollToAnchor(aId);
    return false;
  }
});

// scroll if hashtag
$(document).ready(function(){
  var hash = window.location.hash.replace('#', '');
  if (hash != '') {
    scrll.scrollToAnchor(hash);
  }
});


//* sticky nav =================================================== */

$(window).scroll(function(){
  var scroll_var = $(window).scrollTop();
  if (scroll_var > 200) {
    if (breakpointMin('baby')) {
      $('body').addClass('s_sticky');
    } else {
      $('body').removeClass('s_sticky');
    }
  } else {
    $('body').removeClass('s_sticky');
  }
});


//* focus =================================================== */

document.addEventListener('click', function(e) {
  $('body').removeClass('s_focus-on');
});

document.addEventListener('keydown', function(e) {
  if (e.keyCode === 9 || e.keyCode === 13) {
    $('body').addClass('s_focus-on');
  }
});


//* finder inputs =================================================== */

$(document).on('focus','.storeswitch-input, filter-input',function(){
  $(this).select();
});


//* auto expand textareas =================================================== */
// Applied globally on all textareas with the "l_auto-expand" class
$(document)
.on('focus.l_auto-expand', 'textarea.l_auto-expand', function(){
    var savedValue = this.value;
    this.value = '';
    this.baseScrollHeight = this.scrollHeight;
    this.value = savedValue;
})
.on('input.l_auto-expand', 'textarea.l_auto-expand', function(){
    var minRows = this.getAttribute('data-min-rows')|0, rows;
    this.rows = minRows;
    rows = Math.ceil((this.scrollHeight - this.baseScrollHeight) / 20);
    this.rows = minRows + rows;
});


//* file uploads =================================================== */

function inputFileInit($item) {

  // init
  var $input = $item;
  var $label = $input.next( 'label' );
  var label_val = $label.html();

  // on change input
  $input.on('change', function(e) {

    // get filename(s)
    var fileName = '';
    if (this.files && this.files.length > 1) {
      fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
    } else if( e.target.value ) {
      fileName = e.target.value.split( '\\' ).pop();
    }

    // set filename on label
    if (fileName) {
      $label.html( fileName );
    } else {
      $label.html( labelVal );
    }

  });

  // firefox bug fix
  $input.on('focus', function() {
    $input.addClass('s_focus');
  });
  $input.on('blur', function() {
    $input.removeClass('s_focus');
  });

}

$(document).ready(function(){
  $('.file-upload').each(function() {
    inputFileInit($(this));
  });
});


//* ie11 =================================================== */

if (isIE11) {
  var divNode = document.createElement("div");
  divNode.innerHTML = "<br><style>.storeswitch-or {display:none!important;}.storeswitch-btn{display:none!important;}</style>";
  document.body.appendChild(divNode);
}




//* brand filtering =================================================== */

var classFilterMonth = 'all';
var classFilterCategory = 'all';

function filterBrands() {

  var filterString = '';
  if (classFilterMonth != 'all') {
    filterString += '[data-months*="|' + classFilterMonth + '|"]';
  }
  if (classFilterCategory != 'all') {
    filterString += '[data-categories*="|' + classFilterCategory + '|"]';
  }

  if (filterString == '') {
    $('.brand').addClass('s_active');
    $('.none-found').hide();
  } else {
    $('.brand').removeClass('s_active');
    $('.brand' + filterString).addClass('s_active');
    if (!$('.brand' + filterString).length) $('.none-found').show();
    else $('.none-found').hide();
  }

}

$(document).on('click','[data-action="filterCategory"]',function(){
  classFilterCategory = $(this).attr('data-id');
  $('[data-action="filterCategory"]').removeClass('s_active');
  $(this).addClass('s_active');
  filterBrands();
  return false;
});

$(document).on('click','[data-action="filterMonth"]',function(){
  classFilterMonth = $(this).attr('data-id');
  $('[data-action="filterMonth"]').removeClass('s_active');
  $(this).addClass('s_active');
  filterBrands();
  return false;
});

if (typeof presetCategory !== 'undefined' && presetCategory.length) {
  classFilterCategory = presetCategory;
  $('[data-action="filterCategory"][data-id="'+presetCategory+'"]').addClass('s_active');
  filterBrands();
}

$(document).on('click','.filter2-label',function(){
  $('.filter2-main').toggleClass('s_show');
  return false;
});
